"use client";

import { AsyncBoundary } from "@gerama/ui";
import { songToTrack } from "@/features/player/to-track";
import { publicPath } from "@/lib/public-path";
import { SongRow } from "./song-row";
import { useSongRelated } from "./use-song";

/** "پیشنهادها" under a song — same artist, then category, then newest (`GET /songs/:code/related`). */
export function RelatedSongs({ id, code }: { id: number | string; code?: string }) {
  const query = useSongRelated(id);
  return (
    <AsyncBoundary
      query={query}
      skeleton={<div className="bg-muted h-40 animate-pulse rounded-lg" />}
      isEmpty={(songs) => songs.length === 0}
      empty={null}
      render={(songs) => {
        const queue = songs.map((song) => songToTrack(song));
        return (
          <section className="space-y-3" aria-labelledby="related-songs-heading">
            <h2 id="related-songs-heading" className="text-xl font-bold">
              بیشتر
            </h2>
            <div className="grid gap-x-6 md:grid-cols-2">
              {songs.map((song, i) => (
                <SongRow
                  key={song.id}
                  song={song}
                  index={i}
                  queue={queue}
                  contextLabel="پیشنهادها"
                  contextHref={publicPath("songs", { id, code })}
                />
              ))}
            </div>
          </section>
        );
      }}
    />
  );
}
